import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const messageBubble = tv({
  base: "w-fit max-w-full whitespace-pre-wrap break-words rounded-2xl px-4 py-2.5 text-base/6",
  variants: {
    variant: {
      default: "bg-neutral-50 text-neutral-900",
      own: "bg-red-400 text-white",
    },
    /** Squares the corner nearest the speaker on the last bubble of a run, so the run reads as a
     *  single utterance with one point of origin. Which corner depends on the side it sits on. */
    tail: {
      true: "",
    },
  },
  compoundVariants: [
    { class: "rounded-es-none", tail: true, variant: "default" },
    { class: "rounded-ee-none", tail: true, variant: "own" },
  ],
});

export interface MessageBubbleProps {
  children: ReactNode;
  tail?: boolean;
  variant?: "default" | "own";
}

export function MessageBubble({ children, tail = false, variant = "default" }: MessageBubbleProps) {
  return <div className={messageBubble({ tail, variant })}>{children}</div>;
}
